import { useState } from 'react';
import { CONTENT_MAX_WIDTH } from '../constants';
import { useScreenSize } from '../hooks/useScreenSize';
import { RequestCardModal } from './RequestCardModal';

export const FooterContent = () => {
  const screenSize = useScreenSize();
  const isMobile = screenSize === 'mobile';
  const [showRequestModal, setShowRequestModal] = useState(false);

  return (
    <>
      <footer
        className="footer"
        style={{
          position: 'relative',
          color: '#5D6C70',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          alignItems: 'flex-start',
          gap: 20,
          maxWidth: CONTENT_MAX_WIDTH,
          margin: '0 auto 30px',
        }}
      >
        <div style={{ paddingRight: isMobile ? 0 : 15 }}>
          {/* <ProductName /> */}
          <h3 style={{ margin: 0 }}>CardClues</h3>
        </div>
        <div>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              lineHeight: 1.5,
            }}
          >
            <li>
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
                style={{ fontSize: 12 }}
              >
                Privacy policy
              </a>
            </li>
            {/* <li>
            <a href="/terms-of-service">Terms of service</a>
          </li> */}
            <li>
              <button
                type="button"
                onClick={() => setShowRequestModal(true)}
                className="footer-link"
                style={{
                  fontSize: 12,
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontWeight: 400,
                }}
              >
                Request a card
              </button>
            </li>
            <li>
              <a
                href="mailto:hello@cardclues.com"
                className="footer-link"
                style={{ fontSize: 12 }}
              >
                Contact us
              </a>
            </li>

            {/* <li><a href="/about">About</a></li> */}
          </ul>
          <div>
            <p style={{ fontSize: 12 }}>
              CardClues is a tool for seeing how your credit cards can work
              together and scouting improvements to your wallet. We are an
              independent website and do not receive compensation for card
              placements.
            </p>
            <p style={{ fontSize: 12 }}>
              Reward valuations are estimates based on publicly available data
              and reviewer opinion and are not provided or endorsed by issuers.
            </p>
            <p style={{ fontSize: 12 }}>
              All product names, logos, and brands are property of their
              respective owners. CardClues is not affiliated with, endorsed by,
              or sponsored by any bank or credit card issuer. Chase, American
              Express, Citi, Capital One, and other trademarks are the property
              of their respective holders.
            </p>
            <p style={{ fontSize: 12 }}>
              CardClues is an informational tool that helps you understand how
              credit cards can work together and discover new cards for your
              wallet. We gather data from multiple sources, but it may not
              always be current or accurate. Nothing on this site constitutes
              financial, legal, or tax advice. Always verify details directly
              with the issuer before applying or making financial decisions.
            </p>
            <p style={{ fontSize: 12 }}>
              © 2025 CardClues. All rights reserved. For accessibility inquiries
              or data corrections,{' '}
              <a
                href="mailto:hello@cardclues.com"
                className="footer-link"
                style={{ fontSize: 12 }}
              >
                contact us
              </a>
              .
            </p>
          </div>
        </div>
      </footer>
      {showRequestModal && (
        <RequestCardModal onClose={() => setShowRequestModal(false)} />
      )}
    </>
  );
};
